// This "constantSessionId" is different from "sessionId" located in "interceptors/inject-session-interceptor.ts".
// This one does not change after app restart (tab refreshing).

if (!window.name) {
  window.name = crypto.randomUUID();
}

export const constantSessionId = window.name;
